import { getFullName } from "../../../utils/shared";

export const convertMentionsToIds = (text, users) => {
  const handleMap = new Map();
  for (const u of users) {
    const fullName = getFullName(u).toLowerCase();
    if (fullName) handleMap.set(fullName, u.id);
  }
  const pattern = [...handleMap.keys()]
    .sort((a, b) => b.length - a.length)
    .map((name) => name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
    .join("|");

  return text.replace(new RegExp(`@(${pattern})`, "gi"), (_, name) => {
    const id = handleMap.get(name.toLowerCase());
    return id ? `<@${id}>` : `@${name}`;
  });
};

export const convertIdsToMentions = (text, users) => {
  const idMap = new Map();
  for (const u of users) {
    const fullName = getFullName(u);
    if (fullName) idMap.set(u.id, fullName);
  }

  return text.replace(/<@([\w-]+)>/g, (_, id) => {
    const name = idMap.get(id);
    return name ? `@${name}` : `<@${id}>`;
  });
};
